import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=df2a3056&scoped=true&"
import script from "./SettingsModal.vue?vue&type=script&lang=ts&"
export * from "./SettingsModal.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&id=df2a3056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2a3056",
  null
  
)

export default component.exports